// Multi-province branch master list. Single source of truth for branch
// records that province configs can pull from via getBranchesForProvince().

export interface BranchMasterRecord {
  id: string;
  provinceSlug: string;
  name: string;
  nameEn: string;
  address: string;
  postalCode: string;
  geo?: { lat: number; lng: number };
  isPrimaryForProvince: boolean;
}

export const BRANCHES_MASTER: BranchMasterRecord[] = [
  {
    id: "phuket-patong",
    provinceSlug: "phuket",
    name: "สำนักงานภูเก็ต (ป่าตอง)",
    nameEn: "Phuket Patong Office",
    address: "ถนนบางลา ตำบลป่าตอง อำเภอกะทู้ จังหวัดภูเก็ต 83150",
    postalCode: "83150",
    geo: { lat: 7.8969, lng: 98.2956 },
    isPrimaryForProvince: true,
  },
  {
    id: "phuket-town",
    provinceSlug: "phuket",
    name: "จุดบริการเมืองภูเก็ต (เมืองเก่า)",
    nameEn: "Phuket Town (Old Town) Service Point",
    address:
      "ถนนเฉลิมพระเกียรติ ร.๙ ตำบลตลาดใหญ่ อำเภอเมืองภูเก็ต จังหวัดภูเก็ต 83000",
    postalCode: "83000",
    geo: { lat: 7.8833, lng: 98.3925 },
    isPrimaryForProvince: false,
  },
  {
    id: "phuket-cherngtalay",
    provinceSlug: "phuket",
    name: "จุดบริการลากูน่า–เชิงทะเล",
    nameEn: "Laguna–Cherngtalay Service Point",
    address: "ถนนศรีสุนทร ตำบลเชิงทะเล อำเภอถลาง จังหวัดภูเก็ต 83110",
    postalCode: "83110",
    geo: { lat: 8.0019, lng: 98.2986 },
    isPrimaryForProvince: false,
  },
  {
    id: "phuket-chalong",
    provinceSlug: "phuket",
    name: "จุดบริการอ่าวฉลอง (Yacht & Marine)",
    nameEn: "Chalong Bay Marine Service Point",
    address:
      "ถนนเจ้าฟ้าตะวันออก ตำบลฉลอง อำเภอเมืองภูเก็ต จังหวัดภูเก็ต 83130",
    postalCode: "83130",
    geo: { lat: 7.8424, lng: 98.3386 },
    isPrimaryForProvince: false,
  },
];

export function getBranchesForProvince(provinceSlug: string): BranchMasterRecord[] {
  return BRANCHES_MASTER.filter((b) => b.provinceSlug === provinceSlug);
}

export const NEARBY_PROVINCES_MAP: Record<string, string[]> = {
  phuket: ["พังงา", "กระบี่"],
};